import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Scanner from "./pages/Scanner";
import Shop from "./pages/Shop";
import DealSheet from "./pages/DealSheet";
import DealLookup from "./pages/DealLookup";
import BackOffice from "./pages/BackOffice";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Account from "./pages/Account";
import NotFound from "./pages/NotFound";
import Request from "./pages/Request";
import Upc from "./pages/Upc";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/scanner" element={<Scanner />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/deal" element={<DealSheet />} />
          <Route path="/lookup" element={<DealLookup />} />
          <Route path="/backoffice" element={<BackOffice />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/account" element={<Account />} />
          <Route path="/request" element={<Request />} />
          <Route path="/upc" element={<Upc />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
